import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Box, Tabs } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { TabIds } from '@src/types';
import { PrivacyToolsComponent } from '../privacy-tools/privacy-tools.container';
import { VisitorDataComponent } from '../visitor-data/visitor-data.component';

export interface Props extends InjectedTranslateProps {}
interface IState {
  activeTabId: number;
}

class InnerTabsPageComponent extends React.PureComponent<Props, IState> {
  state: IState = {
    activeTabId: TabIds.PrivacyTools,
  };

  onTabClicked = (value: any) => {
    this.setState({
      activeTabId: value.id,
    });
  };

  render() {
    const { t } = this.props;
    const { activeTabId } = this.state;

    return (
      <>
        <Box marginBottom={'24px'}>
          <Tabs
            dataHook={DataHooks.Tabs}
            activeId={activeTabId}
            onClick={this.onTabClicked}
            hasDivider={true}
            items={[
              { id: TabIds.PrivacyTools, title: t('privacy.tools.tab.title') },
              { id: TabIds.VisitorData, title: t('visitor.data.tab.title') },
            ]}
          />
        </Box>
        {activeTabId === TabIds.PrivacyTools ? <PrivacyToolsComponent /> : <VisitorDataComponent />}
      </>
    );
  }
}

export const TabsPageComponent = translate()(InnerTabsPageComponent);
